module.exports = __webpack_public_path__ + "img/walkthrough_illust25@2x.4b07dd98.png";